import React from "react";

const Practice = () => {
  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            width: "80%",
          }}
        >
          <div
            style={{ backgroundColor: "#FF5E5B", width: "50%", padding: "20px" }}
          >
            <h2
              style={{
                textAlign: "justify",
                fontWeight: "600",
                paddingBottom: "20px",
              }}
            >
              Information Technology Law
            </h2>
            <h2 style={{ textAlign: "justify", fontWeight: "400" }}>
             Juristech IT Law experts provide
              comprehensive legal advice tailored to clients' needs. 
              They assist in drafting agreements, creating data protection policies, conducting compliance
              assessments, and advising on global regulations. With their
              expertise, clients can make informed decisions and minimize risks.
            </h2>
          </div>
          <div
            style={{
              backgroundColor: "black",
              color: "#fff",
              width: "50%",
              padding: "20px",
            }}
          >
            {" "}
            <h2
              style={{
                textAlign: "justify",
                fontWeight: "600",
                paddingBottom: "20px",
                
              }}
            >
              Information Technology Law
            </h2>
            <h2 style={{ textAlign: "justify", fontWeight: "400" }}>
            Cybersecurity law is a rapidly evolving field. Juristech IT Law experts provides expert legal advice and 
              solutions for cybersecurity challenges. Whether you need to 
              comply with new regulations, respond to a cyberattack, or 
              protect your data and assets, Juristech can help you navigate 
              the complex cyber landscape with confidence and professionalism.
            </h2>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            width: "80%",
          }}
        >
          <div
            style={{ backgroundColor: "#C0C0C0", width: "50%", padding: "20px" }}
          >
            <h2
              style={{
                textAlign: "justify",
                fontWeight: "600",
                paddingBottom: "20px",
              }}
            >
              Information Technology Law
            </h2>
            <h2 style={{ textAlign: "justify", fontWeight: "400" }}>
              Juristech IT Law expertsprovide comprehensive legal advice
              tailored to clients' needs. They assist in draftin agreements,
              creating data protection policies, conducting compliance
              assessments, and advising on global regulations. With their
              expertise, clients can make informed decisions and minimize risks.
            </h2>
          </div>
          <div
            style={{ backgroundColor: "#FFFFEA", width: "50%", padding: "20px" }}
          >
            <h2
              style={{
                textAlign: "justify",
                fontWeight: "600",
                paddingBottom: "20px",
              }}
            >
              Information Technology Law
            </h2>
            <h2 style={{ textAlign: "justify", fontWeight: "400" }}>
              Juristech IT Law experts provide comprehensive legal advice
              tailored to clients' needs. They assist in drafting agreements,
              creating data protection policies, conducting compliance
              assessments, and advising on global regulations. With their
              expertise, clients can make informed decisions and minimize risks.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Practice;
